/**
 * Created by Jie Gao on 5/5/2017.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {WixxParsedGameData} from "../../server/data/WixxParsedGameData";
import {WixxGameConfig} from "../../WixxGameConfig";
import {WixxSoundConfig} from "../../WixxSoundConfig";

export class WixxWildLandingAttentionController extends ReelStopPresentationController {

    private _wildHighlight:boolean[][];
    private _stackedReelFourWild:boolean;

    constructor(index:number) {
        super(index, "WildAttentionPresentation");
        this._wildHighlight = [];
        this._stackedReelFourWild = false;
    }

    protected parseFeatureGameData(data:WixxParsedGameData):void {
        this._wildHighlight = data.wildHighlight;
        this._stackedReelFourWild = data.stackedReelFourRespinActive;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(!this.tryPlayBouncePresentation(data)) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private tryPlayBouncePresentation(data:IReelStoppedData):boolean {
        //Do not show wild animation on the stack wild
        if(this._stackedReelFourWild && data.reelId === 3) {
            return false
        }
        let timeline:TimelineLite | undefined;
        let symbol:StateReelSymbol | null;
        let wilds:number = 0;
        for(let i:number = 0; i < 3; i++) {
            symbol = Reels.getSymbol(data.reelId, i);
            if(symbol && this._wildHighlight[data.reelId][i]) {
                if(timeline == undefined) {
                    timeline = new TimelineLite({
                        paused : true,
                        onComplete : () => {this.dispatchCompleteEvent(data.reelId);}
                    });
                }
                timeline.add(symbol.changeState({
                    state : WixxGameConfig.instance.SYMBOL_STATES.attention
                }), 0);
                wilds++;
            }
        }

        if(timeline) {
            timeline.add(() => {
                SlotGame.sound.playEffect(WixxSoundConfig.instance.WILD_LANDING_ATTANTION);
            }, 0);
            timeline.play();
        }
        return wilds > 0;
    }

    protected resetFeature():void {
        this._wildHighlight = [];
        this._stackedReelFourWild = false;
    }
}